module.exports = __webpack_public_path__ + "img/stolethegoods-locked.08c9fc04.png";